module.exports = {
  // 菜单栏Class
  menuClass: {
    enterprise: '公司账户总览',
    personal: '个人账户总览'
  },
  // 登录注册Class
  loginClass: {
    userLogin: '用户端登录界面',
    account: '请输入手机号/邮箱',
    password: '请输入密码',
    login: '登录',
    registerTips: '欢迎注册云钱账号',
    realName: '真实姓名',
    mobile: '手机号',
    verificationCode: '验证码',
    submit: '发送',
    agreeTips: '我已阅读并同意',
    agreementTips: '《云钱账户注册协议》',
    register: '注册',
    registerDone: '注册成功',
    tel: '手机号',
    logout: '退出系统',
    logoutTips: '确定退出登录吗？',
    systemTips: '系统提示',
    cancel: '取消'
  },
  // 企业账户&&个人账户Class
  accountClass: {
    accountRelated: '账户相关',
    corporateAccounts: '公司账户总览',
    accountManagement: '公司关联账号管理',
    accountOverview: '个人账户总览',
    overviewManagement: '账户管理总览',
    cloudPoint: '云积分账户',
    TEUCurrency: 'Tue币',
    recharge: '充值',
    membership: '购买会员',
    details: '交易明细',
    membershipPeriod: '会员有效期',
    benefitsAvailable: '可享受权益',
    welcome: '欢迎',
    userID: '用户ID',
    accountID: '账户 ID',
    exit: '退出',
    personal: '个人',
    personalDetails: '个人交易明细',
    enterpriseDetails: '公司交易明细',
    tips: '请输入被添加用户ID，若被添加人未注册，请先让其注册',
    personalAccountID: '个人账户 ID',
    companyAccountID: '公司账户 ID'
  },
  // 企业交易明细&&个人交易明细Class
  tradingClass: {
    startDate: '起始日期',
    endDate: '截止日期',
    transactionDate: '交易日期',
    tradeSources: '交易来源',
    tradeType: '交易类型ID',
    transactionType: '交易类型',
    all: '全部',
    consumption: '消费',
    reconciliation: '调账',
    transactionGifts: '交易赠送',
    membershipRecharge: '入会充值',
    confirmMembership: '确认会员',
    confirmRecharge: '确认充值',
    cloudBl: '云单',
    cloudBooking: '云舱',
    cloudExhibition: '云展',
    cloudMondy: '云钱',
    mall: '商城',
    transactionTime: '交易时间',
    tradeUserId: '交易人ID',
    trader: '交易人',
    accountName: '账户名',
    transactionNo: '交易编号',
    transactionAmount: '交易金额',
    pointBalance: '积分账户余额',
    amountPay: '实付金额（人民币）',
    usdAmountPay: '实付金额（美金）',
    note: '备注',
    download: 'Excel下载',
    query: '查询',
    account: '账户',
    jyjetcoin: '交易金额（TEU COIN）',
    zhyetcoin: '账户余额(TEU COIN)',
    balance: '余额',
    enterCode: '请输入验证码',
    send: '发送',
    transfer: '转账',
    transferAmount: '转账金额'
  },
  // 会员Class
  membersClass: {
    membersTips1: '需缴纳',
    membersTips2: '元会员费',
    bronzeMember: '青铜会员',
    goldMember: '黄金会员',
    platinumMember: '白金会员',
    benefitsAvailable: '可享受权益',
    paymentChecking: '您已缴费，等待平台人工复核确认中',
    bemembers: '成为会员，享受更多权益',
    nonmembbers: '非会员暂无权益',
    validity: '会员有效期',
    equity: '可享受权益',
    review: '您已缴费，等待平台人工复核确认中',
    selectHoder: '请选择会员等级'
  },
  // 充值Class
  rechargeClass: {
    rechargeAmount: '充值金额',
    wechatPay: '微信支付',
    alipay: '支付宝支付',
    offlinePay: '请转账汇款至以下银行账号',
    qrcode: '支付二维码',
    rechargeTips: '请将XXXX元，转账汇款至XXXX账号，账户名为XXXX，汇款完成后请联系客服，有任何问题请联系XXXX',
    tips1: '请将',
    tips2: '元',
    tips3: '转账汇款至',
    tips4: '账号',
    tips5: '账户名为',
    tips6: '汇款完成后请联系客服，有任何问题请联系',
    rechargeTips: '充值完成，等待确认中！',
    offlinePayTitle: '银行转账'
  },
  // 账号管理Class
  managementClass: {
    userID: '平台用户ID',
    userName: '用户名',
    email: '邮箱',
    permissions: '权限',
    operation: '操作',
    administrator: '管理员（公司首席）',
    payPart: '支付员',
    update: '更新',
    delete: '删除',
    addAccount: '新建关联账号',
    addID: '被添加用户ID',
    managementTips: '请输入被添用户ID,若被添加人未注册,请先让其注册',
    setPermissions: '设置权限',
    select: '请选择',
    sure: '确定',
    updateAccount: '更新关联账号',
    role: '请选择角色权限',
    deleteTips: '您确定要删除',
    deleteTips2: '这个账号吗？',
    tips: '提示',
    cancelDelete: '已取消删除',
    deleteSucc: '删除成功！',
    deleteFuil: '删除失败！'
  },
  checkClass: {
    accountTips: '请输入账户ID',
    permissions: '请选择权限'
  },
  sidebarClass: {
    individualAccount: '个人账户',
    personalOverview: '个人账户总览',
    personalCredit: '个人充值',
    personalDetails: '个人交易明细',
    companyAccount: '公司账户',
    companyOverview: '公司账户总览',
    companyRecharge: '公司充值',
    purchaseMember: '购买会员',
    companyDetails: '公司交易明细',
    accountManagement: '账号管理',
    companyManagement: '公司关联账号管理',
    personalAccountTransfer: '个人转账',
    companyTransfer: '公司转账'
  },
  bankTransferClass: {
    companyAccount: '公司账户',
    remittanceAmount: '汇款金额',
    bankAccount: '开户行',
    account: '户头',
    contact: '联系人',
    contactNumber: '联系电话',
    contactWeChat: '联系微信',
    unit: '元',
    email: 'Email',
    swift: 'SWIFT CODE',
    whatapp: 'WHATSAPP',
    address: '地址'
  },
  commonPayClass: {
    orderNo: '订单编号',
    purpose: '交易类型',
    orderContent: '订单内容',
    paymentMethod: '支付方式',
    amount: '应付金额',
    pay: '立即支付',
    commitBtn: '提交',
    paymentCenter: '支付中心',
    currency: '美元',
    paypalTitle: 'Paypal支付',
    payAmount: '需支付金额',
    teucoinPayment: '云钱支付',
    offlinePayment: '线下对公转账支付',
    onlinePayment: '线上支付',
    balance: '余额',
    centralAccount: '中心账户',
    enterpriseAccount: '企业账户',
    individualAccount: '个人账户',
    verificationCode: '验证码',
    recharge: '充值'
  },
  commonPayResultClass: {
    statusSuccessTitle: '支付完成',
    statusFailTitle: '支付失败',
    resultSuccessTitle: '恭喜您，订单支付完成！',
    resultFailTitle: '很抱歉，订单支付失败！',
    orderNo: '订单编号',
    slipNo: '支付流水单编号',
    paymentMethod: '支付方式',
    amount: '支付金额',
    returnBack: '返回系统',
    returnInvoiceBack: '申请发票',
    currency: '美元',
    accountId: 'TEUCOIN账户',
    copyBtn: '复制',
    orderInfo: '订单信息',
    accountInfo: '收款账户',
    returnHome: '返回首页',
    selectOrder: '查看订单',
    paymentCompleted : '支付成功',
    paymentDescription : '您可以在个人中心“我的订单”中查看'
  },
  offlineInfoClass: {

  },
  // 开具发票
  invoiceInfoClass: {
    companyName: '名称',
    invoiceTaxNo: '税号',
    address: '地址',
    phone: '电话',
    bankName: '开户行',
    bankCode: '账号',
    amount: '开具金额',
    issuedPhone: '推送电话',
    issuedEmail: '推送邮箱',
    selectsure: '确认',
    cancel: '取消',
    invoiceCompanyNameNotNull: '名称不能为空',
    invoiceTaxNoNotNull: '税号不能为空',
    permissionsinvoiceIssuedPhoneNotNull: '推送电话不能为空',
    invoiceIssuedEmailNotNull: '推送邮箱不能为空'

  }
}
